import React, { useEffect } from 'react';
import { Route, Switch } from 'react-router-dom';
import InnerHeader from './InnerHeader';
import EngineeringDecisionTree from './EngineeringDecisionTree';
import CustomerDecisionTree from './CustomerDecisionTree';

const SopRedirect = () => {
  useEffect(() => {
    window.open('https://quip-amazon.com/6as0AYa0W7RB/SCOT-New-Grocery-Node-Forecast-Launch-SOP', '_blank');
  }, []); 
  return (
    <div>
      <p>If the SOP document didn't open automatically, please click the link below:</p>
      <a href="https://quip-amazon.com/6as0AYa0W7RB/SCOT-New-Grocery-Node-Forecast-Launch-SOP" target="_blank" rel="noopener noreferrer">
        Open SOP Document
      </a>
    </div>
  );
};

const GSCTeamRedirect = () => {
  useEffect(() => {
    window.open('https://w.amazon.com/bin/view/SCOT/Forecasting/Hermes', '_blank');
  }, []); 
  return (
    <div>
      <p>If the page didn't open automatically, please click the link below:</p>
      <a href="https://w.amazon.com/bin/view/SCOT/Forecasting/Hermes" target="_blank" rel="noopener noreferrer">
        Open SOP Document
      </a>
    </div>
  );
};

export default function App() {
  return (
    <div>
      <Switch>
        <Route exact path="/" >
          <InnerHeader />
          <EngineeringDecisionTree />
        </Route>
        <Route exact path="/engineeringDecisionTree" >
          <InnerHeader />
          <EngineeringDecisionTree />
        </Route>
        <Route exact path="/customerDecisionTree" >
          <InnerHeader />
          <CustomerDecisionTree />
        </Route>
        <Route exact path="/sop" component={SopRedirect} />
        <Route exact path="/gscTeam" component={GSCTeamRedirect} />

      </Switch>
    </div>
  );
}
